import { VendorBuyingAgreementDocumentsList } from '../../../components/Vendor';

export function BuyingAgreementDocuments() {
  return <VendorBuyingAgreementDocumentsList />;
}
